import React from "react";
import { AppBar, Toolbar, Typography, styled } from "@mui/material";
import mediapark from "../assets/mediapark.png";

const StyledToolbar = styled(Toolbar)({
  display: "flex",
  justifyContent: "space-between",
});

const Navbar = () => {
  return (
    <>
      <AppBar
        component="nav"
        position="sticky"
        sx={{
          backgroundColor: "#FF6D00",
        }}
        elevation={0}
        style={{
          top: 0,
          left: 0,
          width: "100%",
          zIndex: 1000, // Zorgt ervoor dat de AppBar boven de afbeelding wordt weergegeven
        }}
      >
        <StyledToolbar>
          <Typography variant="h6" component="h2">
            Young Innovative Thinkers
          </Typography>
        </StyledToolbar>
      </AppBar>
      <div style={{ position: "relative", width: "100%" }}>
        <img
          src={mediapark}
          alt=""
          style={{
            width: "100%",
          }}
        />
      </div>
    </>

    // <>
    //   <AppBar
    //     component="nav"
    //     position="sticky"
    //     sx={{
    //       backgroundColor: "#FF6D00",
    //     }}
    //     elevation={0}
    //   >
    //     <StyledToolbar>
    //       <Typography variant="h6" component="h2">
    //         Young Innovative Thinkers
    //       </Typography>
    //     </StyledToolbar>
    //   </AppBar>

    //   <img
    //     src={mediapark}
    //     alt=""
    //     style={{
    //       width: "100%",
    //     }}
    //   />
    // </>
  );
};

export default Navbar;
